import { LinkifiedSegments, TextLink } from "@/components/ui/LinkifiedText";
import type { Locale } from "@/i18n/config";
import { localizedText } from "@/i18n/text";
import { parseLinks, soleLink } from "@/lib/linkify";
import { cn } from "@/lib/utils";

/**
 * A requirements profile's description, which is the landlord's rental policy
 * (DH Marknad's `rentalPolicy`), labelled as such.
 *
 * Landlords often enter nothing but a link to the policy on their own site. That
 * reads as "Uthyrningspolicy – https://…" on one line; longer text gets the label
 * above it instead.
 */
export function RentalPolicyText({
  text,
  locale,
  className,
}: {
  text: string;
  locale: Locale;
  className?: string;
}) {
  const segments = parseLinks(text);
  const link = soleLink(segments);
  const label = localizedText(locale, "Uthyrningspolicy", "Rental policy");

  if (link) {
    return (
      <p className={cn("break-words", className)}>
        <span className="font-medium text-gray-900">{label}</span>
        {" – "}
        <TextLink href={link.href} label={link.label} />
      </p>
    );
  }

  return (
    <div className={className}>
      <p className="font-medium text-gray-900">{label}</p>
      <p className="mt-1 whitespace-pre-wrap break-words">
        <LinkifiedSegments segments={segments} />
      </p>
    </div>
  );
}
